"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GladiatorsParryAbilityHandler = exports.GladiatorsParryActorAbilityFactory = exports.GladiatorsParryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
const Settings_1 = require("../../Settings");
class GladiatorsParryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GladiatorsParry;
        this.__typeName = "GladiatorsParry";
    }
}
exports.GladiatorsParryAbilityArgs = GladiatorsParryAbilityArgs;
let GladiatorsParryActorAbilityFactory = class GladiatorsParryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GladiatorsParry", "Self", 4);
    }
};
GladiatorsParryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GladiatorsParry")
], GladiatorsParryActorAbilityFactory);
exports.GladiatorsParryActorAbilityFactory = GladiatorsParryActorAbilityFactory;
let GladiatorsParryAbilityHandler = class GladiatorsParryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyBuff({
                    sequence: sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Toughness")),
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId))
                    ], false)
                });
            }
        });
    }
};
GladiatorsParryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GladiatorsParry)
], GladiatorsParryAbilityHandler);
exports.GladiatorsParryAbilityHandler = GladiatorsParryAbilityHandler;
